import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { MethodTypeKind } from '@protocols/use-cases';

interface MethodTypePipeline {
  pipeline: string;
  configId: string;
}

interface MethodTypeLabelConfig {
  label: string;
  configId: string;
  color: string;
}

export interface MethodTypeAcquisitionField {
  displayName: string;
  fieldPath: string;
}

export interface MethodTypeStateItem {
  id: string;
  name?: string;
  type?: MethodTypeKind;
  pipelineIds?: Record<string, MethodTypePipeline>;
  labelConfig?: Record<string, MethodTypeLabelConfig>;
  acquisitionFields?: MethodTypeAcquisitionField[];
}

interface MethodTypeStateModel {
  methodType: MethodTypeStateItem | null;
  loading: boolean;
  error: string | null;
}

const INITIAL_STATE: MethodTypeStateModel = {
  methodType: null,
  loading: false,
  error: null,
};

@Injectable()
export class MethodTypeState extends ComponentStore<MethodTypeStateModel> {
  constructor() {
    super({ ...INITIAL_STATE });
  }

  public readonly methodType$ = this.select((state) => state.methodType);
  public readonly loading$ = this.select((state) => state.loading);
  public readonly error$ = this.select((state) => state.error);

  public readonly setMethodType = this.updater(
    (state, methodType: MethodTypeStateItem | null) => ({ ...state, methodType })
  );

  public readonly setLoading = this.updater((state, loading: boolean) => ({
    ...state,
    loading,
  }));

  public readonly setError = this.updater((state, error: string | null) => ({
    ...state,
    error,
  }));
}
